var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment, useContext, useEffect, useMemo, useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import { ColumnTypes } from '../../helpers/table';
import ExactaTableContext from '../../context/ExactaTableContext';
var StyledDialogTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var AdditionalFilters = function (_a) {
    var _b = _a.additionalFilters, additionalFilters = _b === void 0 ? [] : _b, onApplyAdditionalFilters = _a.onApplyAdditionalFilters;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var exactaTableContext = useContext(ExactaTableContext);
    var _d = useState({}), filters = _d[0], setFilters = _d[1];
    useEffect(function () {
        var appliedAdditionalFilters = {};
        Object.keys(exactaTableContext.additionalFilters).forEach(function (appliedFilterKey) {
            appliedAdditionalFilters[appliedFilterKey] = filters[appliedFilterKey];
        });
        setFilters(appliedAdditionalFilters);
    }, [exactaTableContext.additionalFilters]);
    var t = useTranslation().t;
    if (additionalFilters.length === 0) {
        return null;
    }
    var handleOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var applyFilters = function () {
        onApplyAdditionalFilters(Object.keys(filters).reduce(function (acc, currentFilterKey) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[currentFilterKey] = filters[currentFilterKey].value, _a)));
        }, {}));
        handleClose();
    };
    var addFilter = function (filter) {
        setFilters(function (prevValue) {
            var _a;
            return __assign(__assign({}, prevValue), (_a = {}, _a[filter.alias] = __assign(__assign({}, filter), { value: '' }), _a));
        });
    };
    var addFilterValue = function (filterKey, value) {
        setFilters(function (prevValue) {
            var _a;
            return __assign(__assign({}, prevValue), (_a = {}, _a[filterKey] = __assign(__assign({}, prevValue[filterKey]), { value: value }), _a));
        });
    };
    var onRemoveFilter = function (key) {
        setFilters(function (prevValue) {
            delete prevValue[key];
            return __assign({}, prevValue);
        });
    };
    var onResetFilters = function () {
        setFilters({});
    };
    console.log({ filters: filters });
    var filterKeys = Object.keys(filters);
    return (React.createElement(Fragment, null,
        React.createElement(Tooltip, { title: "Additional Filters" },
            React.createElement(IconButton, { "aria-label": "additional-filters" },
                React.createElement(Icon, { onClick: handleOpen }, "filter_alt"))),
        React.createElement(Dialog, { fullWidth: true, maxWidth: "sm", open: open, onClose: handleClose, scroll: 'paper', "aria-labelledby": "scroll-dialog-title", "aria-describedby": "scroll-dialog-description" },
            React.createElement(DialogTitle, null,
                React.createElement(StyledDialogTitle, null,
                    React.createElement(Typography, { variant: "subtitle1" }, t('dialogTitle.additionalFilters')),
                    React.createElement(FilterMenu, { additionalFilters: additionalFilters, addFilter: addFilter }))),
            React.createElement(DialogContent, { dividers: true }, filterKeys.length === 0 ? (React.createElement(Typography, { variant: "subtitle2" }, t('general.noFilters'))) : (filterKeys.map(function (filterKey) {
                return (React.createElement(Grid, { item: true, xs: 12, key: filterKey },
                    React.createElement(FilterRow, { alias: filterKey, filterDefinition: filters[filterKey], addFilterValue: addFilterValue, onRemoveFilter: onRemoveFilter })));
            }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { color: "primary", onClick: onResetFilters }, t('general.reset')),
                React.createElement(Button, { color: "primary", onClick: handleClose }, t('general.close')),
                React.createElement(Button, { color: "primary", onClick: applyFilters }, t('general.filter'))))));
};
var FilterMenu = function (_a) {
    var additionalFilters = _a.additionalFilters, addFilter = _a.addFilter;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event) {
        setAnchorEl(null);
    };
    var handleSelect = function (event, filter) {
        addFilter(filter);
        handleClose(event);
    };
    return (React.createElement("div", null,
        React.createElement(IconButton, { "aria-controls": 'long-menu', "aria-haspopup": "true", onClick: handleClick },
            React.createElement(Icon, null, "filter_alt")),
        React.createElement(Menu, { id: "long-menu", anchorEl: anchorEl, keepMounted: true, open: open, onClose: handleClose, PaperProps: {
                style: {
                    maxHeight: 48 * 4.5,
                    width: '20ch',
                },
            } }, additionalFilters.map(function (filter) {
            return (React.createElement(MenuItem, { key: filter.alias, onClick: function (evt) { return handleSelect(evt, filter); } }, filter.alias));
        }))));
};
var FilterRow = function (_a) {
    var alias = _a.alias, filterDefinition = _a.filterDefinition, addFilterValue = _a.addFilterValue, onRemoveFilter = _a.onRemoveFilter;
    var removeFilter = function () {
        onRemoveFilter(alias);
    };
    var handleValueChange = function (value) {
        addFilterValue(alias, value);
    };
    return (React.createElement(Grid, { container: true, spacing: 1 },
        React.createElement(Grid, { item: true, xs: 10 },
            React.createElement(FilterMenuItemsByType, { alias: alias, filterDefinition: filterDefinition, handleValueChange: handleValueChange })),
        React.createElement(Grid, { item: true, xs: 2 },
            React.createElement(IconButton, null,
                React.createElement(Icon, { onClick: removeFilter }, "delete")))));
};
export var FilterMenuItemsByType = function (_a) {
    var alias = _a.alias, filterDefinition = _a.filterDefinition, handleValueChange = _a.handleValueChange;
    var _b;
    var type = filterDefinition.type, value = filterDefinition.value, _c = filterDefinition.options, options = _c === void 0 ? [] : _c;
    var t = useTranslation().t;
    switch (type) {
        case ColumnTypes.TEXT_FIELD:
            var handleTextFieldChange = function (evt) {
                handleValueChange(evt.target.value);
            };
            return (React.createElement(TextField, { onChange: handleTextFieldChange, type: "text", fullWidth: true, label: t("form.label." + alias), value: value, variant: "outlined" }));
        case ColumnTypes.BOOLEAN_FIELD:
            return (React.createElement(TextField, { select: true, fullWidth: true, label: t("form.label." + alias), value: value, variant: "outlined" },
                React.createElement(MenuItem, { value: "" + true, onClick: function () { return handleValueChange(true); } }, "True"),
                React.createElement(MenuItem, { value: "" + false, onClick: function () { return handleValueChange(false); } }, "False")));
        case ColumnTypes.CHOICE_FIELD:
            return (React.createElement(Fragment, null,
                React.createElement(FilterChoicesField, { alias: alias, onFilterChange: handleValueChange, filterDefinition: filterDefinition })));
        case ColumnTypes.SELECT_FIELD:
            return (React.createElement(TextField, { select: true, fullWidth: true, label: t("form.label." + alias), value: value, variant: "outlined" }, (_b = options) === null || _b === void 0 ? void 0 : _b.map(function (option) {
                return (React.createElement(MenuItem, { key: option.id, value: option.id, selected: option.alias === value, onClick: function () { return handleValueChange(option.alias); } }, option.alias));
            })));
        default:
            return React.createElement(MenuItem, null, "Not yet implemented");
    }
};
var FilterChoicesField = function (_a) {
    var alias = _a.alias, filterDefinition = _a.filterDefinition, onFilterChange = _a.onFilterChange;
    var t = useTranslation().t;
    var value = filterDefinition.value, choiceGroupAlias = filterDefinition.choiceGroupAlias;
    var choiceGroups = useSelector(function (state) { return state.choiceGroups; });
    var options = useMemo(function () { var _a; return (_a = choiceGroups[choiceGroupAlias]) === null || _a === void 0 ? void 0 : _a.nodes; }, [
        choiceGroupAlias,
        choiceGroups,
    ]);
    return (React.createElement(TextField, { select: true, fullWidth: true, label: t("form.label." + alias), value: value, variant: "outlined" }, options.map(function (option) { return (React.createElement(MenuItem, { key: option.id, value: option.alias, selected: option.alias === value, onClick: function () { return onFilterChange(option.alias); } }, option.alias)); })));
};
export default AdditionalFilters;
var templateObject_1;
//# sourceMappingURL=AdditionalFilters.js.map